// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__rsFDD","legacyBtn":"MutateMid_legacyBtn__2deW4"};